module.exports = __webpack_public_path__ + "img/img_gymm2@2x.ee050359.png";